import React from "react"
import ReactApexChart from "react-apexcharts"

const LineColumnArea = ({ returnDashboardData, store }) => {
  if (!returnDashboardData || !returnDashboardData.counts_data) {
    return (
      <div style={{textAlign: 'center', color: '#888', padding: '2rem'}}>
        No data available for the selected period.
      </div>
    );
  }
  const returnDashboard = returnDashboardData.counts_data;
  // If store === 'all', show store names as labels
  let rejectedData = [], approvedData = [], authorizedData = [], labels = [];
  if (store && store.toLowerCase() === 'all') {
    // counts_data is an object with store names as keys
    Object.entries(returnDashboard).forEach(([storeName, storeData]) => {
      labels.push(storeName);
      approvedData.push(storeData.approved || 0);
      rejectedData.push(storeData.rejected || 0);
      authorizedData.push(storeData.authorized || 0);
    });
  } else {
    // Dynamically build chart data for all months in the year
    const year = Object.keys(returnDashboard)[0] || "";
    const months = [
      "jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"
    ];
    if (year) {
      // Helper to get value for each month from array of objects
      const getMonthValue = (arr, month) => {
        if (!Array.isArray(arr)) return 0;
        const found = arr.find(obj => obj && typeof obj === 'object' && obj.hasOwnProperty(month));
        return found ? Number(found[month]) : 0;
      };
      const rejectedArr = returnDashboard[year]?.rejected || [];
      const approvedArr = returnDashboard[year]?.approved || [];
      const authorizedArr = returnDashboard[year]?.authorized || [];
      months.forEach(m => {
        rejectedData.push(getMonthValue(rejectedArr, m));
        approvedData.push(getMonthValue(approvedArr, m));
        authorizedData.push(getMonthValue(authorizedArr, m));
        labels.push(m.charAt(0).toUpperCase() + m.slice(1) + ' ' + year);
      });
    }
  }

  const series = [
    {
      name: "Approved",
      type: "bar",
      data: approvedData,
    },
    {
      name: "Rejected",
      type: "area",
      data: rejectedData,
    },
    {
      name: "Authorized",
      type: "line",
      data: authorizedData,
    },
  ];
  const options = {
    chart: {
      stacked: false,
      toolbar: {
        show: false,
      },
    },
    stroke: {
      width: [0, 2, 4],
      curve: "smooth",
    },
    plotOptions: {
      bar: {
        columnWidth: "50%",
      },
    },
  // Set approved (bar) to green, rejected (area) to red, authorized (line) to blue (order matches series)
  colors: ["#34c38f", "#f46a6a", "#556ee6"],

    fill: {
      opacity: [0.85, 0.25, 1],
      gradient: {
        inverseColors: false,
        shade: "light",
        type: "vertical",
        opacityFrom: 0.85,
        opacityTo: 0.55,
        stops: [0, 100, 100, 100],
      },
    },
  labels: labels.length > 0 ? labels : ["-"],
    markers: {
      size: 0,
    },
    legend: {
      offsetY: 11,
    },
    xaxis: {
      type: "category",
    },
    yaxis: {
      title: {
        text: "Counts",
      },
    },
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: function (y) {
          if (typeof y !== "undefined") {
            return y.toFixed(0) + " counts"
          }
          return y
        },
      },
    },
    grid: {
      borderColor: "#f1f1f1",
    },
  }

  // Show fallback if no data
  const hasData = (rejectedData.length > 0 && approvedData.length > 0 && (rejectedData.some(v => v !== 0) || approvedData.some(v => v !== 0)));

  return (
    <>
      {!hasData && (
        <div style={{textAlign: 'center', color: '#888', padding: '2rem'}}>
          No data available for the selected period.
        </div>
      )}
      {hasData && (
        <ReactApexChart
          options={options}
          series={series}
          type="line"
          height="350"
        />
      )}
    </>
  )
}

export default LineColumnArea
